import React, { useEffect, useState } from 'react';
import QualityTrendChart from '../chart/QualityTrendChart';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader"
import DetailedNCReport from '../modal/DetailedNCReport';
export default function QualityNcReports() {
  const [detailencReport, setDetailencReport] = useState(false)
  const [nc_report, setNcReport] = useState([])
  const [ncReason, setNcReason] = useState([])
  const [materialReport, setMaterialReport] = useState([])
  const [loading, setLoading] = useState(false);
  const fetchNCReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/nc_report_summary`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setNcReport(result);
        console.log("nc_report:", result.data);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching setNcReport", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchNCReason = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/common_nc_reason`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (response.status === 200 && result?.success === true) {
        setNcReason(result?.data);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching setNcReport", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMaterialReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/inspection_material_report`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (response.status === 200 && result?.success === true) {
        setMaterialReport(result);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching setNcReport", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNCReport()
    fetchNCReason()
    fetchMaterialReport()
  }, [])

  return (
    <div className='container-fluid mt-3'>
      <QualityTrendChart />
      <div className="row g-3 mt-3 font_family">
        <div className="col-12 col-md-6">
          <div className="p-3 border rounded bg-light">
            <h5 className="fw-bold mb-3">NC Reports Summary</h5>
            {
              loading ? (
                <Loader />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <span className="text-muted">Total NCs This Month</span>
                    <span className="fs-5 fw-bold">{nc_report?.data?.total_ncs}</span>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">New</div>
                        <div className="fw-bold text-danger fs-5">{nc_report?.data?.open_ncs}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">In Progress</div>
                        <div className="fw-bold text-warning fs-5">{nc_report?.data?.inprogress_ncs}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">Resolved</div>
                        <div className="fw-bold text-success fs-5">{nc_report?.data?.closed_ncs}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">Escalated</div>
                        <div className="fw-bold text-primary fs-5">{nc_report?.data?.escalated_ncs}</div>
                      </div>
                    </div>
                  </div>
                </>
              )
            }
            {/* <button className="btn btn-outline-secondary w-100" onClick={()=>setDetailencReport(true)}>
                View Detailed NC Report
              </button> */}
          </div>


        </div>
        <div className="col-12 col-md-6">
          <div className="p-3 border rounded bg-light h-100">
            <div className="">
              <h5 className="fw-bold mb-3">Most Common NC Reasons</h5>
              {
                loading ? (
                  <Loader />
                ) : (
                  <ul className="list-unstyled mb-4">
                    {ncReason?.length > 0 ? (
                      ncReason.map((item, index) => (
                        <li key={index} className="d-flex justify-content-between mb-2">
                          <span>{item.reason}</span>
                          <span className="fw-bold">{Number(item.percentage).toFixed(2)}%</span>
                        </li>
                      ))
                    ) : (
                      <li className="text-center text-muted">Data Not Found</li>
                    )}
                  </ul>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <div className="card p-4 shadow-sm mt-4">
        <h5 className="fw-bold mb-4">Inspection & Material Reports</h5>
        <div className="row g-4">
          <div className="col-12 col-md-6">
            <h6 className="fw-semibold mb-3">Incoming Material Inspection</h6>
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {materialReport?.incoming_material?.length > 0 ? (
                materialReport.incoming_material.map((item, idx) => (
                  <div
                    key={idx}
                    className={`mb-3 p-3 border rounded mb-3 p-3 border rounded bg-danger-subtle`}
                  >
                    <div className="d-flex">
                      <strong>{item.material_master?.material_name}</strong>
                      <strong className="ms-auto"> Quantity : {item.total_quantity ?? 0}{item?.material_master?.unit_of_measurement}</strong>
                    </div>
                    <div className="text-muted">
                      {item?.material_master?.material_code || "No description available"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted text-center">No Incoming Material Found</div>
              )}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <h6 className="fw-semibold mb-3">Stock Level Alerts</h6>
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {materialReport?.floor_stock?.length > 0 ? (
                materialReport?.floor_stock.map((item, idx) => (
                  <div
                    key={idx}
                    className={`mb-3 p-3 border rounded mb-3 p-3 border rounded bg-danger-subtle`}
                  >
                    <div className="d-flex">
                      <strong>{item.material?.material_name}</strong>
                      <strong className="ms-auto"> Quantity : {item.total_quantity} {item?.material?.unit_of_measurement}</strong>
                    </div>
                    <div className="text-muted">{item?.material?.material_code}</div>
                  </div>
                ))
              ) : (
                <div className="text-muted text-center">No Stock Alerts Found</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <DetailedNCReport
        show={detailencReport}
        handleClose={() => setDetailencReport(false)}
      />
    </div>
  )
}
